<template>
  <div>
    <el-card>
      <el-form ref="form" :model="form" :rules="typesettingRules" class="typesettingForm" label-width="220px">
        <el-row>
          <el-col :span="24">
            <el-form-item class="rowc" label="排版片数：" prop="typesetting_phr">
              <el-input
                ref="typesetting_phr_ref"
                v-model="form.typesetting_phr"
                maxlength="9"
                show-word-limit
                @input="form.typesetting_phr = keepNum99(form.typesetting_phr)"
                @keyup.enter.native="typesetting_phrKeyup"
              >
                <template slot="append">片</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="rowc">
            <el-form-item label="岗位：" prop="stff_position">
              <el-input v-model="form.stff_position" disabled maxlength="9" show-word-limit> </el-input>
            </el-form-item>
            <el-form-item label="填卡人：" prop="user_id">
              <el-select v-model="form.user_id" disabled filterable placeholder="请选择">
                <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工序制作人：" prop="user_producer_id">
              <el-select v-model="form.user_producer_id" filterable placeholder="请选择">
                <el-option v-for="item in stffList2" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <sub-table ref="subTable" :stffList="stffList2" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item align="center" class="ml_10">
          <el-button class="determine" type="success" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="typesettingDialogVisible" width="70%">
      <h2 class="diaTitle">提示：提交排版信息, 是否继续</h2>
      <div class="diaContent">
        <el-button class="determine" @click="typesettingDialogVisible = false">取 消</el-button>
        <el-button class="determine" type="primary" @click="typesettingDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import helper from '@assets/js/helper.js';
import SubTable from '@/views/OperateManagement/ReadManage/TabChild/subTable.vue';

export default {
  components: { SubTable },
  computed: {
    helper() {
      return helper;
    }
  },
  data() {
    return {
      form: {
        typesetting_phr: '',
        user_id: '',
        user_producer_id: '',
        stff_position: ''
      },
      typesettingRules: {
        typesetting_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请填写排版用量', trigger: true }
        ]
      },
      typesettingDialogVisible: false
    };
  },
  props: {
    prop: {
      type: Object
    },
    stffList: {
      type: Array
    },
    stffList2: {
      type: Array
    }
  },
  methods: {
    submit() {
      if (!this.prop.rfid_id) {
        return this.$message.error('请刷卡');
      }
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.typesettingDialogVisible = true;
        }
      });
    },
    typesettingDialog() {
      this.typesettingDialogVisible = false;
      let form = {};
      form.rfid_id = this.prop.rfid_id;
      form.user_rfid_no = this.prop.user_rfid_no;
      form.typesetting_phr = this.form.typesetting_phr;
      form.user_producer_id = this.form.user_producer_id;
      form.user_id = this.form.user_id;
      form.stff_position = this.prop.user_jobs;
      form.rfid_typesetting_id = this.prop.rfid_typesetting_id;
      form.rfid_typesetting_item = this.$refs.subTable.tableData.filter(x =>
        x.rfid_typesetting_id ? true : !x.rfid_typesetting_id && !x.destroy_flag
      );
      post(rfidAPI.edit_typesetting, form)
        .then(res => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success(res.data.msg);
          this.$refs['form'].resetFields();
          this.$emit('empty');
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    typesetting_phrKeyup() {},
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  mounted() {
    this.$EventBus.$on('typesetting', () => {
      this.form.typesetting_phr = '';
      this.form.user_id = '';
      this.form.user_producer_id = '';
      this.form.stff_position = '';
    });
    this.$EventBus.$on('typesettingEmit', res => {
      this.form.typesetting_phr = res.typesetting_phr;
      this.form.user_id = res.user_id || this.$cookies.get('userInfo').user_id;
      this.form.user_producer_id = res.user_producer_id || this.$cookies.get('userInfo').user_id;
      this.form.stff_position = res.stff_position;
      if (!this.$refs.typesetting_phr_ref) {
        return;
      } else {
        this.$refs.typesetting_phr_ref.focus();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.typesettingForm .el-form-item {
  margin-bottom: 10px;
}

.typesettingForm {
  width: 90%;
  margin: 0 auto;
  min-width: 500px;
}

::v-deep .typesettingForm .el-form-item__label {
  font-size: $font-max;
}

::v-deep .typesettingForm .el-input {
  font-size: $font-max;
  height: 60px;
}

::v-deep .el-form-item__content {
  margin-bottom: 20px;
}

::v-deep .typesettingForm .el-input input {
  height: 60px;
}

::v-deep .el-form-item__error {
  font-size: 18px;
  margin-bottom: 2px;
}
</style>
